import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const CaixaSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4080" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4080)"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5651 10.9907L11.8401 12.7001H12.8435L12.5684 10.9837L12.5651 10.9907ZM8.72388 14.9148L11.6982 9.12161H13.9471L15.2011 14.9148H13.2269L13.0814 14.1427H11.1661L10.7254 14.9148H8.72388ZM16.1358 14.9148L16.9974 9.12161H18.9867L18.1255 14.9148H16.1358ZM29.3669 10.9837L28.639 12.7001H29.642L29.3669 10.9837ZM25.5224 14.9148L28.4971 9.12161H30.7456L32 14.9148H30.0254L29.8803 14.1427H27.9646L27.524 14.9148H25.5224Z"
        fill="#0070AF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1243 12.206H23.6171L25.3252 14.882H22.832L21.1243 12.206Z"
        fill="#0070AF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3835 11.795H23.9602L26.198 9.13025H23.6214L21.3835 11.795Z"
        fill="#F6822A"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8071 14.8982H21.3834L23.6212 12.2009H21.0445L18.8071 14.8982Z"
        fill="#F6822A"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7363 9.09765H22.1409L23.7885 11.7949H21.3835L19.7363 9.09765Z"
        fill="#0070AF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.78267 9.32892L8.59138 11.0329C7.85816 10.0759 6.15873 10.7363 6.02528 11.9284C5.8557 13.4413 7.49128 13.794 8.3813 12.9031L8.1896 14.611C7.92397 14.7343 7.66418 14.8302 7.40778 14.8948C7.15277 14.9597 6.89719 14.9941 6.64361 14.9992C6.3248 15.0057 6.03595 14.974 5.77571 14.9048C5.51547 14.8368 5.27995 14.7285 5.07158 14.5823C4.66972 14.3043 4.37915 13.9509 4.20016 13.521C4.02118 13.0895 3.96228 12.6027 4.02326 12.0587C4.07243 11.6214 4.18884 11.2227 4.37437 10.8612C4.5583 10.5001 4.8131 10.1714 5.13755 9.87371C5.44426 9.58991 5.77828 9.37571 6.13972 9.23032C6.49978 9.0861 6.89269 9.00916 7.31741 9.00065C7.57111 8.99563 7.82002 9.0196 8.06159 9.07489C8.30446 9.1298 8.54397 9.21563 8.78267 9.32892Z"
        fill="#0070AF"
      />
    </Svg>
  )
}
